<template>
	<div class="productcenter">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>产品中心</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="content-left">
						<p>产品列表</p>
						<el-col style="border: 1px solid #dfdfdf;">
							<el-menu
							default-active="2"
							class="el-menu-vertical-demo"
							:default-openeds="openeds"
							@open="handleOpen"
							@close="handleClose">
								<div v-for="(item,index) in navList" :key="index">
									<el-submenu v-if="item.children" :index="item.id">
										<template slot="title">
											<span @click="getData(item.id)" style="width:100%;display:block">{{item.name}}</span>
										</template>
										<el-menu-item v-for="child in item.children" :index="item.id+'-'+child.id">
											<span @click="getData(child.id)" style="width:100%;display:block">{{child.name}}</span>
										</el-menu-item>
									</el-submenu>
									<el-menu-item v-if="!item.children" :index="item.id">
										<span @click="getData(item.id)" slot="title">{{item.name}}</span>
									</el-menu-item>
								</div>
							</el-menu>
						</el-col>
					</div>
					
					<div class="content-right">
						<ul>
							<li 
								v-for="(product,index) in listData" 
								@click="gotoDetail(product.id)">
								<img :src="product.default_img"/>
								<p>{{product.name}}</p>
							</li>
						</ul>

						<div class="nomore" v-if="listData.length == 0">
							<i class="el-icon-refresh"></i>暂时没有更多信息显示
						</div>
						<div class="pages">
							<el-pagination
					            @current-change="handleCurrentChange"
								background
								layout="prev, pager, next"
								v-if="total>1?true:false"
								:total="total"
								pagesize="9"
								style="float:right">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
	<div style="clear:both;"></div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		id:'',
		data(){
			return{
				msg:'productcenter',
				activeNames: ['1','2','3','4','5'],
				currentPage1:1,
				navList:[],
				listData:[],
				total:1,
				pagesize:2,
				currentPage:1,
				banner:'',
				openeds:[]
			}
		},
		methods: {
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getList(this.id);
	        },
	        handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    },
			gotoDetail(id){
				this.$router.push({
							path:'/ProDetail',
							query: {
				          		id:id,
				          	}
				        })
			},
			getData(id){
				this.currentPage=1;
				this.getList(id);
			},
			getItemList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productItemApi,
					data: {}
				})
				.then((res) => {
					this.navList = res.data.data;
					var arr = res.data.data[0];
					var id = this.$route.params.id;
					for (var i = 0; i < this.navList.length; i++) {
						this.openeds.push(this.navList[i].id);
					}
					console.log(id);
					if(!id){
						this.getList(0);
					}else{
						this.getList(id);
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getList(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productListApi+id+/page/+this.currentPage,
					data: {}
				})
				.then((res) => {
					this.listData = res.data.data;
					this.total = parseInt(res.data.total);
					this.id = id;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'5',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner5;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getItemList();
			this.getBanner();
		}
	}
	
	
	
	

</script>

<style lang="less" scoped="scoped">
.productcenter{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
	}
	.content{
		margin-top: 50px;
		margin-bottom: 50px;
		.content-left{
			display: inline-block;
			width: 25%;
			border-box:box-sizing;
			font-size:18px;
			p{
				width: 100%;
				height: 40px;
				text-align: left;
				line-height: 40px;
				padding-left: 40px;
				font-size: 18px;
				background: #229dfe;
				color: #fff;
			}
			.mosttitle{
				font-size: 20px;
				margin-left: 15px;
			}
			.clicklist{
				font-size: 16px;
				padding-left: 20px;
				margin-top: 5px;
				margin-left: 5px;
				cursor: pointer;
				.disc{
						display: inline-block;
						width: 5px ;
						height: 5px;
						background: #146BFF;
						border-radius: 50%;
						margin-right: 10px;
						margin-bottom: 3px;
					}
			}
			
		}
		.content-right{
			display: inline-block;
			width: 73%;
			float: right;
			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				li{
					width:32%;
					border-radius:5px;
					overflow:hidden;
					cursor:pointer;
					margin-bottom: 25px;
					box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
					margin-right:calc(4%/3);
					img{
						width:100%;
						display:block;
					}
					p{
						padding:14px;
						text-align:center;
					}
				}
				li:hover{
					transform:scale(1.02,1.02);
					box-shadow: 0 2px 12px 0 rgba(34,157,254,.5);
				}
			}
		}
	}
	.el-menu{
		border:0px;
	}
	.nomore{
			font-size: 20px;
			text-align: center;
			margin-top: 50px;
			margin-bottom: 30px;
		}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/ProductCenter.vue